export default __webpack_public_path__ + "static/media/mMT5.5167fde0.png";